import { MdSettings } from 'react-icons/md';
import { PhoneControlButtonProps } from '../types';
import Button from '../../../buttons/button';

export const SettingsButton: React.FC<PhoneControlButtonProps> = ({
  onClick,
  disabled = true,
  size = 'md',
}) => {
  return (
    <Button
      variant="neutral"
      appearance="soft"
      size={size}
      onClick={onClick}
      disabled={disabled}
      className="rounded-full flex-shrink-0"
      isIconOnly
    >
      <MdSettings className="w-5 h-5" />
    </Button>
  );
};
